import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/activity/pages/maohao.svg'
import _imports_1 from '../../assets/activity/pages/arrow.svg'
import _imports_2 from '../../assets/activity/pages/rule.png'


const _withScopeId = n => (_pushScopeId("data-v-b00f2662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-layout" }
const _hoisted_2 = { class: "container-layout-wrapper" }
const _hoisted_3 = { class: "container-top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "custom-indicator" }
const _hoisted_7 = { class: "content-two" }
const _hoisted_8 = { class: "left-wrapper" }
const _hoisted_9 = { class: "current-price" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$", -1))
const _hoisted_11 = { class: "current-price-big" }
const _hoisted_12 = { class: "recovery" }
const _hoisted_13 = { class: "last-time" }
const _hoisted_14 = { class: "last-time-top" }
const _hoisted_15 = { class: "last-time-block" }
const _hoisted_16 = { class: "last-time-bottom" }
const _hoisted_17 = { class: "last-time-block" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "last-time-block-maohao" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_19 = { class: "last-time-block" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "last-time-block-maohao" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_21 = { class: "last-time-block" }
const _hoisted_22 = { class: "content-three" }
const _hoisted_23 = { class: "content-three-title" }
const _hoisted_24 = { class: "content-three-join" }
const _hoisted_25 = { class: "content-three-join-number" }
const _hoisted_26 = { class: "content-process" }
const _hoisted_27 = { class: "content-four-top" }
const _hoisted_28 = { class: "content-four-top-content" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "process" }, "活动流程", -1))
const _hoisted_30 = { class: "rule" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_33 = { class: "popup-content" }
const _hoisted_34 = { class: "popup-content-title" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "popup-content-title-circle" }, null, -1))
const _hoisted_36 = { class: "popup-content-item" }
const _hoisted_37 = { class: "process-wrapper-box" }
const _hoisted_38 = { class: "process-wrapper-order" }
const _hoisted_39 = { class: "content-five" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-five-title" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(" 活动详情 "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_41 = { class: "content-five-content" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "content-footer" }

import { ref, reactive, onMounted, defineAsyncComponent } from "vue";
import { LocationQueryValueRaw, useRoute } from "vue-router";
import { CurrentCode } from "@/api/currentCode";
import { Activity, activityResponse, GroupShareResponse } from "@/api/activity";
import { Button } from "vant";
import { allCountries } from "@/components/IndexBarCode/data/country";
import store from "store2";
import { getCookie } from "@/utils/service/request";
import useShare from "./hooks/useShare";
import { WxTicket } from "@/api/wxTicket";
import {
  initConfig,
  updateAppMessageShareData,
  updateTimelineShareData,
} from "@/hooks/useWxSDK";
import { useRouter } from "vue-router";
interface DefineCode {
  countryCode: string; //国家代码 "CN"
  code: string; // 区号 "86"
}
interface RuleDesc {
  title: string;
  content: string;
}
//CSS 接口
type Cls = {
  two: boolean;
  three: boolean;
  process_wrapper_item_five: boolean;
  process_wrapper_item_four: boolean;
  process_wrapper_item_three: boolean;
  process_wrapper_item_two: boolean;
};
type BoxFlag = {
  six_box: boolean;
  five_box: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
//接口定义
const LoginGet = defineAsyncComponent(
  () => import("@/components/LoginGet.vue")
);
// const props = defineProps<{ pid: string }>();
//变量和函数定义
const route = useRoute();
const flag: Cls = reactive({
  two: false,
  three: false,
  process_wrapper_item_five: false,
  process_wrapper_item_four: false,
  process_wrapper_item_three: false,
  process_wrapper_item_two: false,
});
const boxFlag: BoxFlag = reactive({
  six_box: false,
  five_box: false,
});
const actionSheetStatus = ref<boolean>(false);
const defineCode = reactive<DefineCode>({
  countryCode: "CN",
  code: "86",
});
const activityInfo = reactive<activityResponse>({
  userId: 0,
  id: 0,
  h5Title: "", //h5标题
  bannerUrls: "",
  price: 0, //活动标价
  scribingPrice: 0, //划线价
  activityTitle: "", //活动标题
  endTime: 0, //	结束时间(时间戳)
  activityProcess: "", //	活动流程
  ruleDesc: "", //规则说明
  detailsImgurl: "", //	详情页图片
  footBtnText: "", //底部按钮文案
  openGroupExplain: "", //开团说明
  joinPeopleNum: 0, //参与人数
});
const activityProcessArr = ref<Array<string>>([]);
const activityTitleArr = ref<Array<string>>([]);
const bannerUrlsArr = ref<Array<string>>([]);
const ruleDescArr = ref<Array<RuleDesc>>([]);

const d = ref<number>();
const h = ref<number>(0);
const m = ref<number>(0);
const s = ref<number>(0);
const getTimeFunc = () => {
  //获取当前时间
  let nowTime = new Date().getTime();
  const time = new Date(activityInfo.endTime);
  // console.log(time)
  const end = time.getTime();
  //时间差
  let gapTime = end - nowTime;
  // console.log(gapTime)
  if (gapTime >= 0) {
    d.value = Math.floor(gapTime / 1000 / 60 / 60 / 24);
    h.value = Math.floor((gapTime / 1000 / 60 / 60) % 24);
    m.value = Math.floor((gapTime / 1000 / 60) % 60);
    s.value = Math.floor((gapTime / 1000) % 60);
  }
};
setInterval(getTimeFunc, 1000);
const show = ref<boolean>(false);
const showRule = () => {
  show.value = true;
};
const { aid, pid } = route.query;
const { isWeixin } = useShare();
function setCookie(cookiename: any, cookievalue: any) {
  const date = new Date();
  // if (type === 'milsecond') {
  //   date.setTime(date.getTime() + milsecond)
  // } else {
  date.setDate(date.getDate() + 99999);
  // }
  document.cookie =
    cookiename +
    "=" +
    cookievalue +
    ";expires = " +
    date.toUTCString() +
    ";path=/";
}
const shareInfo = reactive<GroupShareResponse>({
  id: 0, //id
  shareTitle: "", //分享标题
  shareText: "", //分享文本
  shareImgUrl: "", //分享图片
});
const isTrue = ref<LocationQueryValueRaw | LocationQueryValueRaw[]>();

onMounted(async () => {
  try {
    const res = await CurrentCode.getAreacode(); //获取国家代码和国家名称
    for (const item of allCountries) {
      if (
        res.code.toUpperCase() === item[1].toUpperCase() ||
        res.name === item[3]
      ) {
        defineCode.countryCode = item[1]; //国家代码 "CN"
        defineCode.code = item[2]; //区号 "86"
      }
    }
  } catch (error) {
    console.log(error);
  }
  
  try {
    const res = await Activity.activityGet({ id: Number(aid) });
    activityInfo.userId = res.userId;
    activityInfo.id = res.id;
    const xxx = getCookie("aid");
    console.log(xxx);
    if (xxx === aid && activityInfo.userId) {
      window.location.href = `/startGroup/${activityInfo.userId}?aid=${
        activityInfo.id
      }&isLogin=${true}&isAuto=${true}`;
    }
    // if (activityInfo.userId) {
    //   console.log("8888888");
    //   router.push({
    //     path: `/startGroup/${activityInfo.userId}`,
    //     query: {
    //       aid: activityInfo.id,
    //       isLogin: ,
    //     },
    //   });
    activityInfo.h5Title = res.h5Title;
    document.title = res.h5Title;
    activityInfo.price = res.price;
    activityInfo.scribingPrice = res.scribingPrice;
    activityInfo.activityTitle = res.activityTitle;
    activityInfo.activityProcess = res.activityProcess;
    activityInfo.detailsImgurl = res.detailsImgurl;
    activityInfo.footBtnText = res.footBtnText;
    activityInfo.joinPeopleNum = res.joinPeopleNum;
    activityInfo.endTime = res.endTime;
    activityInfo.bannerUrls = res.bannerUrls;
    activityInfo.ruleDesc = res.ruleDesc;

    activityProcessArr.value = activityInfo.activityProcess.split("#");
    if (activityProcessArr.value[activityProcessArr.value.length - 1] === "") {
      activityProcessArr.value.pop();
    }

    activityTitleArr.value = activityInfo.activityTitle.split("#");
    bannerUrlsArr.value = activityInfo.bannerUrls.split(",");
    ruleDescArr.value = JSON.parse(activityInfo.ruleDesc);
    const length = activityProcessArr.value.length;
    if (length === 6) {
      boxFlag.six_box = true;
    } else if (length === 5) {
      flag.process_wrapper_item_five = true;
      boxFlag.five_box = true;
    } else if (length === 4) {
      flag.process_wrapper_item_four = true;
    } else if (length === 3) {
      flag.process_wrapper_item_three = true;
    } else if (length === 2) {
      flag.process_wrapper_item_two = true;
    } else {
      return flag;
    }
  } catch (error) {
    console.log(error);
  }

  if (isWeixin()) {
    const resShare = await Activity.groupShare({ id: Number(aid) });
    shareInfo.shareTitle = resShare.shareTitle;
    shareInfo.shareText = resShare.shareText;
    shareInfo.shareImgUrl = resShare.shareImgUrl;
    const { ticket } = await WxTicket.getWxTicket();
    await initConfig(
      {
        appId: process.env.VUE_APP_WX_APP_ID as string,
        timestamp: parseInt(String(new Date().getTime() / 1000)), //时间戳
        nonceStr: "asdfaskldjflkajskd", //随机字符串
      },
      ticket,
      window.location.href
    );
    const shareParams = {
      title: shareInfo.shareTitle, // 分享标题
      desc: shareInfo.shareText, // 分享描述
      link: window.location.href, //分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareInfo.shareImgUrl, //分享图标
      success() {
        // 用户确认分享后执行的回调函数
        console.log("success");
      },
      cancel() {
        // 用户取消分享后执行的回调函数
        console.log("cancel");
      },
    };
    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    updateAppMessageShareData(shareParams);
    // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
    updateTimelineShareData(shareParams);
  }
});
function HelpClick() {
  actionSheetStatus.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_swipe, {
            autoplay: 3000,
            "lazy-render": ""
          }, {
            indicator: _withCtx(({ active, total }) => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(active + 1) + "/" + _toDisplayString(total), 1)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerUrlsArr.value, (item) => {
                return (_openBlock(), _createBlock(_component_van_swipe_item, { key: item }, {
                  default: _withCtx(() => [
                    (item.search('.mp4') != -1)
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 0,
                          controls: "",
                          src: item
                        }, null, 8, _hoisted_4))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: item,
                          alt: ""
                        }, null, 8, _hoisted_5))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(activityInfo.price), 1)
            ]),
            _createElementVNode("div", _hoisted_12, " 即将恢复原价$" + _toDisplayString(activityInfo.scribingPrice), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createTextVNode(" 距离结束还剩 "),
              _createElementVNode("span", _hoisted_15, _toDisplayString(d.value), 1),
              _createTextVNode(" 天 ")
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(h.value), 1),
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString(m.value), 1),
              _hoisted_20,
              _createElementVNode("span", _hoisted_21, _toDisplayString(s.value), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("p", null, _toDisplayString(activityTitleArr.value[0]), 1),
            _createElementVNode("p", null, _toDisplayString(activityTitleArr.value[1]), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createTextVNode(" 已有 "),
            _createElementVNode("span", _hoisted_25, _toDisplayString(activityInfo.joinPeopleNum), 1),
            _createTextVNode(" 人参与成功 ")
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", { onClick: showRule }, [
                  _createTextVNode(" 规则说明 "),
                  _hoisted_31
                ]),
                _createVNode(_component_van_popup, {
                  round: "",
                  show: show.value,
                  "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
                  closeable: "",
                  position: "bottom",
                  style: { height: '60%' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_32,
                    _createElementVNode("ul", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ruleDescArr.value, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.title
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createTextVNode(" " + _toDisplayString(item.title), 1)
                          ]),
                          _createElementVNode("div", _hoisted_36, _toDisplayString(item.content), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["show"])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(['content-four-wrapper', boxFlag])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityProcessArr.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "process-wrapper",
                key: index
              }, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", {
                    class: _normalizeClass([flag, 'process_wrapper_item'])
                  }, _toDisplayString(item), 3),
                  _createElementVNode("span", _hoisted_38, _toDisplayString(index + 1), 1)
                ])
              ]))
            }), 128))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("img", {
              src: activityInfo.detailsImgurl,
              alt: ""
            }, null, 8, _hoisted_42)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createVNode(_unref(Button), {
          class: "help-button",
          onClick: HelpClick,
          block: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(activityInfo.footBtnText), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (actionSheetStatus.value)
      ? (_openBlock(), _createBlock(_unref(LoginGet), {
          key: 0,
          aid: _unref(aid),
          pid: _unref(pid),
          "define-code": defineCode,
          actionSheetStatus: actionSheetStatus.value,
          "onUpdate:actionSheetStatus": _cache[1] || (_cache[1] = ($event: any) => ((actionSheetStatus).value = $event))
        }, null, 8, ["aid", "pid", "define-code", "actionSheetStatus"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})